import { render } from "./ThePortal.vue?vue&type=template&id=66677132"
import script from "./ThePortal.vue?vue&type=script&lang=js"
export * from "./ThePortal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__